import {Maybe, MetadataItem, MetadataItemType, ProviderFieldsFragment} from 'api/generated';
import {PropertyList} from 'components/PropertyList';
import humanize from 'humanize-string';
import {formatBoolean} from 'lib/formaters';
import React from 'react';
import {MetadataLabel} from './Metadatalabel';

type Props = {
  provider: Maybe<ProviderFieldsFragment>;
  loading: boolean;
};

const sortMetadata = (a: Maybe<MetadataItem>, b: Maybe<MetadataItem>) => {
  if (!a || !b) return 0;
  return b.type.localeCompare(a.type);
};

const formatValue = (item: MetadataItem) => {
  switch (item.type) {
    case MetadataItemType.BOOLEAN:
      return formatBoolean(item.value === 'true', 'Yes', 'No');
    case MetadataItemType.STRING_ARRAY:
      return item.value ? JSON.parse(item.value).map(humanize).join(', ') : 'All';
    default:
      return item.value;
  }
};

export const ProviderMetadataList: React.FC<Props> = ({provider, loading}) => {
  if (!provider?.metadata) return null;
  const metadata = provider.metadata.filter((item) => !item.secret).sort(sortMetadata);
  return (
    <PropertyList
      omitEmpty
      loading={loading}
      labelWidth={500}
      properties={
        metadata.map((item) => ({
          label: <MetadataLabel item={item} />,
          value: formatValue(item)
        })) || []
      }
    />
  );
};
